module.exports = __webpack_public_path__ + "img/solar-radio.17a8ff2d.png";